import React, { useEffect } from "react";
import classNames from "classnames";
import eventBus from "../utils/eventBus";
import Icon from "./Icon";
import { useCBookTheme } from "../hooks";
import { injectIntl } from "react-intl";
import UIPicture from "./ui/UIPicture";
var AppHeader = function(param) {
    var setUIVisibilityState = param.setUIVisibilityState, logoUrl = param.logoUrl, slideTitle = param.slideTitle, uiVisibilityState = param.uiVisibilityState, cbookName = param.cbookName, chapters = param.chapters, intl = param.intl, navDisabled = param.navDisabled, notify = param.notify, logoLink = param.logoLink, currentSlide = param.currentSlide, goTo = param.goTo;
    useEffect(function() {
        var handleOnKeyUp = function() {
            setUIVisibilityState({
                menu: true,
                quickNav: false
            });
        };
        eventBus.register("q", "app", handleOnKeyUp);
        // Clean up event when component unmounts
        return function cleanup() {
            eventBus.unregister("q", "app");
        };
    }, []);
    var isAccessibleTheme = useCBookTheme().isAccessibleTheme;
    return /*#__PURE__*/ React.createElement("header", {
        id: "header",
        className: "app-header",
        tabIndex: 0
    }, /*#__PURE__*/ React.createElement("button", {
        id: "navigation",
        role: "navigation",
        className: "menu-toggler",
        disabled: navDisabled,
        onClick: function() {
            if (navDisabled) {
                notify("action_not_allowed_while_exam");
            } else {
                setUIVisibilityState({
                    menu: !uiVisibilityState.menu,
                    quickNav: false
                });
            }
        },
        "aria-label": intl.formatMessage({
            id: "ui.toggle_menu",
            defaultMessage: "Chapter overview"
        })
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chapters",
        size: "m"
    })), /*#__PURE__*/ React.createElement("button", {
        id: "a11y-modal",
        className: "a11y-toggler",
        "aria-label": "Show accessibility toolbar",
        onClick: function() {
            setUIVisibilityState({
                accessibilityToolbar: !uiVisibilityState.accessibilityToolbar
            });
        }
    }, isAccessibleTheme ? /*#__PURE__*/ React.createElement(Icon, {
        name: "accessibility",
        size: "m"
    }) : /*#__PURE__*/ React.createElement(Icon, {
        name: "circle-question",
        size: "m"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "header-chart-meta"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cbook-name"
    }, cbookName), /*#__PURE__*/ React.createElement("ul", {
        className: "chapter-list"
    }, chapters.map(function(c, i) {
        var classes = classNames("chapter-list__chapter", {
            "chapter-list__chapter--top": i === 0,
            "chapter-list__chapter--closest": i === chapters.length - 1
        }, "chapter-level-".concat(i));
        return /*#__PURE__*/ React.createElement("li", {
            key: c.id,
            className: classes,
            dangerouslySetInnerHTML: {
                __html: c.name
            }
        });
    }))), /*#__PURE__*/ React.createElement("span", {
        tabIndex: 0,
        className: "header-chart-title",
        dangerouslySetInnerHTML: {
            __html: slideTitle
        }
    }), logoUrl ? logoLink ? /*#__PURE__*/ React.createElement("a", {
        href: "#",
        onClick: function(evnt) {
            evnt.preventDefault();
            goTo(logoLink, currentSlide);
        }
    }, /*#__PURE__*/ React.createElement(UIPicture, {
        src: logoUrl,
        className: "logo",
        alt: "Logo",
        title: "Logo"
    })) : /*#__PURE__*/ React.createElement(UIPicture, {
        src: logoUrl,
        className: "logo",
        alt: "Logo",
        title: "Logo"
    }) : null);
};
export default injectIntl(AppHeader);
